import { render, staticRenderFns } from "./CampaignRewardTable.vue?vue&type=template&id=48149dc0&scoped=true"
import script from "./CampaignRewardTable.vue?vue&type=script&lang=js"
export * from "./CampaignRewardTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignRewardTable.vue?vue&type=style&index=0&id=48149dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48149dc0",
  null
  
)

export default component.exports